// extracted by mini-css-extract-plugin
export default {"MainCont":"Oven_MainCont__18wP1","LeftCont":"Oven_LeftCont__6rtLp","RightCont":"Oven_RightCont__M03dT"};